import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../../_models/user-name-display-result-dto';

export class BatchResultDto extends UserNameDisplayResultDto {
    batchID: number;
    managementCompanyID: number;
    communityID: number;
    type: string;
    title: string;
    customInfo: string;
    @Type(() => Date)
    postDate: Date;
    @Type(() => Date)
    deletedDate: Date;
    @Type(() => Date)
    updatedTime: Date;
    allowDelete: boolean;
    scheduledForDelete: boolean;
}
